import React from "react";
import clsx from "clsx";
import { Collapse } from "reactstrap";
import MisPlantillasDiv from "../MisPlantillasDiv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight, faFolder } from "@fortawesome/free-solid-svg-icons";
import DeleteModeal from "../DeleteModal";
import { getPrice } from "../../../utils";
import {
  usePublicTemplateList,
  useRemovePublicTemplate,
} from "../../../api/hooks/public-templates";
import { useCategoryList } from "../../../api/hooks/categories";
import { useModalsDispatch, OPEN_PREVIEW } from "../../../context/modals";

import NoFoldersScreen from ".//noFoldersScreen";
import { SpinnerContainer } from '../../SpinnerContainer'
function TemplateFolders() {
  const { data, isLoading } = useCategoryList({
    populate: 'publicTemplatesCount'
  });
  console.log(data?.data);

  return (
    <SpinnerContainer isLoading={isLoading}>
      <section className="publicadas__section--abogados">
        {data?.hasPublicTemplates ? (
          data?.data?.filter(category => category.publicTemplateCount).map((category) => (
            <TemplateFolderListContainer
              key={category._id}
              title={category.name}
              category={category._id}
              totalTemplates={category.publicTemplateCount}
            />
          ))
        ) : (
          <NoFoldersScreen
            width={"94%"}
            text={"Crea tu primera plantilla y empieza a ganar"}
          />
        )}
      </section>
    </SpinnerContainer>
  );
}

export default TemplateFolders;

function TemplateFolderListContainer({ title, category, totalTemplates = 0 }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { data = {}, isLoading } = usePublicTemplateList({
    enabled: isOpen,
    onlyMyTemplates: true,
    category,
  });
  const { mutate: removePublicTemplateMutate } = useRemovePublicTemplate();
  const modalsDispatch = useModalsDispatch();
  const handlePreview = (template) => {
    modalsDispatch({ type: OPEN_PREVIEW, template, center: true });
  };
  const handleRemove = (template, publicTemplate) => {
    removePublicTemplateMutate({ templateId: publicTemplate._id });
  };

  const toggle = () => setIsOpen((open) => !open);

  return (
    <TemplateFolderList
      isOpen={isOpen}
      title={title}
      total={totalTemplates}
      isLoading={isLoading}
      items={data?.data}
      toggle={toggle}
      onPreview={handlePreview}
      onRemove={handleRemove}
    />
  );
}

function TemplateFolderList({
  title,
  total,
  items = [],
  isOpen,
  toggle,
  isLoading,
  onPreview,
  onRemove,
}) {
  return (
    <div className="publicadas__section--abogados--container">
      <div
        className="section--abogados--container__header"
        onClick={toggle}
        style={{ cursor: "pointer" }}
      >
        <FontAwesomeIcon
          icon={faCaretRight}
          className={clsx(
            "section--abogados--container__header__toggleButton fa-lg ",
            isOpen && "toggleButton_____Active"
          )}
          id="Teletrabajo"
          color={"#f37b33"}
        />
        <FontAwesomeIcon
          icon={faFolder}
          color={"#f37b33"}
          className="fa-lg section--abogados--container__header__toggleFolder"
        />
        <h3 style={{ fontWeight: "600" }}>{title}</h3>
        <span>({total})</span>
      </div>
      <Collapse isOpen={isOpen}>
        <SpinnerContainer isLoading={isLoading}>
          {items.length ? (
              <div className="section--abogados--container__plantillas">
                {items.map((item) => (
                  <MisPlantillasDiv
                    {...item}
                    onPreview={onPreview}
                    onRemove={onRemove}
                  />
                ))}
              </div>
            ) : (
              <span>Sin Plantillas</span>
            )}
        </SpinnerContainer>
        
      </Collapse>
    </div>
  );
}
